import { render, staticRenderFns } from "./SLAEventItem.vue?vue&type=template&id=47f4f498&"
import script from "./SLAEventItem.vue?vue&type=script&setup=true&lang=js&"
export * from "./SLAEventItem.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports